import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['element'];
    static values = {
        showMultiple: { type: Boolean, default: true }
    };

    toggle(event) {
        const currentTarget = event.currentTarget;
        const isExpanded = currentTarget.getAttribute('aria-expanded') === 'true';
        
        if (!this.showMultipleValue) {
            this.elementTargets.forEach((element) => {
                if (element !== currentTarget) {
                    element.setAttribute('aria-expanded', 'false');
                }
            });
        }
        currentTarget.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    }
}
